import { ModBox, Spacer } from '@jfs/ui-new'
import { ButtonNew as Button } from '../../components/AdminButton'
import { useEffect, useState } from 'react'
import { useWindowDimensions } from 'react-native'
import { Container } from '../../components/Container'
import { Dropdown } from '../../components/Dropdown'
import { ModalAlertView } from '../../components/ModalAlertView'
import { NewTable } from '../../components/NewTable'
import { useLazyApiData, useStores } from '../../data/store'
import { isAccessible } from '../../utils'
import { AddNewDevicePlanModel } from './AddNewDevicePlanModel'

const ViewAndAddDevicePlans = () => {
  const {
    deviceVariantList,
    variantPlanList,
    getDevicesListAsync,
    getVariantPlanListAsync,
    deleteDevicePlanAsync,
    addNewDevicePlanAsync,
    accessConfig,
  } = useStores((store) => ({
    deviceVariantList: store.onboarding.deviceVariantList,
    getDevicesListAsync: store.onboarding.getDevicesListAsync,
    getVariantPlanListAsync: store.onboarding.getVariantPlanListAsync,
    variantPlanList: store.onboarding.variantPlanList,
    deleteDevicePlanAsync: store.onboarding.deleteDevicePlanAsync,
    addNewDevicePlanAsync: store.onboarding.addNewDevicePlanAsync,
    accessConfig: store.user.getAccessConfig(['merchant_config', 'device_plans']),
  }))

  const headerTitles = isAccessible(accessConfig, 'delete')
    ? {
        id: 'Plan Id',
        variantRefId: 'Variant Ref Id',
        oneTimeFee: 'One Time Fee',
        recurringFee: 'Recurring Fee',
        mandateRuleAmount: 'Mandate Rule Amount',
        status: 'STATUS',
        actionDownload: ' ',
      }
    : {
        id: 'Plan Id',
        variantRefId: 'Variant Ref Id',
        oneTimeFee: 'One Time Fee',
        recurringFee: 'Recurring Fee',
        mandateRuleAmount: 'Mandate Rule Amount',
        status: 'STATUS',
      }

  const [lazyGetDeviceListAsync, getDeviceListAsyncHandler] = useLazyApiData(getDevicesListAsync)
  const [lazyGetPlanListAsync, getPlanListAsyncHandler] = useLazyApiData(getVariantPlanListAsync)
  const [lazyAddPlanAsync, addPlanAsyncHandler] = useLazyApiData(addNewDevicePlanAsync)

  const [selectedVariantId, setSelectedVariantId] = useState('')
  const [showAddNewPlanModel, setShowAddNewPlanModel] = useState(false)

  const [showConfirmAlert, setShowConfirmAlert] = useState(false)
  const [clickedPlanId, setClickedPlanId] = useState('')
  const [deviceType, setDeviceType] = useState('VOICEBOX')

  useEffect(() => {
    setSelectedVariantId('')
    lazyGetDeviceListAsync(deviceType)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceType])

  const onDropDownValueChanged = (variantId: string) => {
    setSelectedVariantId(variantId)
    lazyGetPlanListAsync(variantId.split('-')[0])
  }

  useEffect(() => {
    if (addPlanAsyncHandler.state === 'fulfilled') {
      setShowAddNewPlanModel(false)
      selectedVariantId && lazyGetPlanListAsync(selectedVariantId.split('-')[0])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addPlanAsyncHandler.state])

  const onRetry = () => {
    if (!selectedVariantId) {
      lazyGetDeviceListAsync(deviceType)
    } else {
      lazyGetPlanListAsync(selectedVariantId.split('-')[0])
    }
  }
  const { width }: any = useWindowDimensions()
  const deviceListData = deviceVariantList?.map((item) => ({ value: item?.id + '- ' + item?.name }))

  return (
    <Container
      isLoading={getDeviceListAsyncHandler.state === 'pending' || getPlanListAsyncHandler.state === 'pending'}
      errorMessage={
        (getDeviceListAsyncHandler.state === 'rejected' && getDeviceListAsyncHandler?.data?.message) ||
        (getPlanListAsyncHandler.state === 'rejected' && getPlanListAsyncHandler?.data?.message)
      }
      onRetry={onRetry}>
      <Dropdown
        label="Select Device Type"
        title="Device Type"
        value={deviceType}
        data={[
          { id: 'VOICEBOX', value: 'VOICEBOX' },
          { id: 'SQR', value: 'SQR' },
        ]}
        selectedData={(type) => setDeviceType(type as string)}
      />
      <Spacer size={20} />
      <Dropdown
        data={deviceListData}
        title={'Device Variant'}
        label={'Select Device Variant'}
        selectedData={onDropDownValueChanged}
        value={selectedVariantId}
      />
      <Spacer size={20} />
      <Button
        onPress={() => setShowAddNewPlanModel(true)}
        type={'primaryIcon'}
        width={180}
        height={40}
        icon="ADD"
        hide={!isAccessible(accessConfig, 'add')}
        title={'Add new Plan'}
      />
      <Spacer size={20} />
      <ModBox show={selectedVariantId} height={'100%'}>
        <NewTable
          data={variantPlanList}
          rowHeight={48}
          headerHeight={64}
          tableWidth={width > 1200 ? width - 290 : width}
          headerRowKeys={headerTitles}
          customWidthFunc={getCustomColumnWidth}
          // onRowEditClicked={onItemChecked}
          freezeColumn={'selected'}
          onAction={(_, id) => {
            setShowConfirmAlert(true)
            setClickedPlanId(id)
          }}
          onRowClick={() => {}}
        />
      </ModBox>
      <ModalAlertView
        message={'Are you sure you want to delete this  variant?'}
        show={showConfirmAlert}
        showHeader={false}
        isConfirmationCheckRequired={false}
        title={''}
        buttonTitle={'Delete'}
        cancelTitle={'Dismiss'}
        onDismiss={() => setShowConfirmAlert(false)}
        onPress={async () => {
          const resp = await deleteDevicePlanAsync(clickedPlanId).catch((ex) => {})
          lazyGetPlanListAsync(selectedVariantId.split('-')[0])
          setShowConfirmAlert(false)
        }}
        onCancel={() => setShowConfirmAlert(false)}
        positiveButtonColor={'PRIMARY'}
        cancelButtonColor={'WHITE'}
        height={80}
        width={400}
      />
      <AddNewDevicePlanModel
        show={showAddNewPlanModel}
        onDismiss={() => {
          setShowAddNewPlanModel(false)
          if (addPlanAsyncHandler.data) {
            addPlanAsyncHandler.data.message = ''
          }
        }}
        onPress={(args: any) => {
          const { variantId, recurringFee, oneTimeFee, mandateRuleAmount } = args
          args.variantId = variantId?.split('-')?.[0]
          if (!recurringFee || +recurringFee <= 0) {
            args.mandateRuleAmount = '0'
          }
          if (!mandateRuleAmount && +recurringFee) {
            args.mandateRuleAmount = Math.max(oneTimeFee, recurringFee)
          }
          lazyAddPlanAsync(args)
        }}
        deviceType={deviceType}
        selectedDevice={selectedVariantId}
        deviceListData={deviceListData}
        errorMessage={addPlanAsyncHandler.state === 'rejected' && addPlanAsyncHandler?.data?.message}
        isLoading={addPlanAsyncHandler.state === 'pending'}
      />
    </Container>
  )
}

export const getCustomColumnWidth = (columnKey: string) => {
  const columnsKeyWidth: any = {
    id: 80,
    variantRefId: 80,
    oneTimeFee: 80,
    recurringFee: 80,
    mandateRuleAmount: 80,
    status: 80,
    actionDownload: 80,
  }
  return columnsKeyWidth[columnKey] ?? 150
}

export default ViewAndAddDevicePlans
